import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accordionTitle: {
    id: 'components.Quiz.Forms.Tabs.MainRoom.accordionTitle',
    defaultMessage: 'Pregunta'
  }
});
